import {FC} from 'react';
import {Box, Flex, Center} from '@chakra-ui/react';
import {Control, Controller} from 'react-hook-form';
import {copyToClipboard, ICredentialsForm} from 'core';
import {detect} from 'detect-browser';
import {Input, Svg} from 'ui-kit';

import {VerifyStep} from './components';

interface IProps {
  verifyUrl: string;
  control: Control<ICredentialsForm>;
}

const CODE_SNIPPED = "window.addEventListener('message', (e) => console.log(e.data?.token));";

export const VerifyFieldsForm: FC<IProps> = ({verifyUrl, control}) => {
  const browser = detect();

  const goToProton = () => {
    window.open(verifyUrl, '_blank');
  };

  const isSafari = browser?.name === 'safari';

  return (
    <Box>
      <Flex flexDirection={'column'} gap={'24px'}>
        <VerifyStep step={1} title={'Open the Proton page'}>
          <Center
            h={'32px'}
            p={'0 12px'}
            gap={'8px'}
            w={'fit-content'}
            onClick={goToProton}
            borderRadius={'4px'}
            color={'{colors.textLink}'}
            bg={'{colors.btnPrimarySuperlight}'}
            _hover={{cursor: 'pointer'}}
          >
            <Box>Go to Proton Url</Box>
            <Svg name={'Link'} size={'s20'} />
          </Center>
        </VerifyStep>

        <VerifyStep step={2} title={'Run the token snippet'}>
          <Box>
            {isSafari
              ? 'Open DevTools → Right click on page, then click Inspect Element and paste this code:'
              : 'Open DevTools → Console F12 (or Fn + F12) and paste this code:'}
          </Box>
          <Flex
            mt={'8px'}
            h={'40px'}
            p={'0 12px'}
            alignItems={'center'}
            justifyContent={'space-between'}
            border={'1px solid'}
            borderColor={'borderDefault'}
            borderRadius={'4px'}
          >
            <Box userSelect={'all'} lineHeight={'16px'}>
              {CODE_SNIPPED}
            </Box>
            <Svg name={'Copy'} onClick={() => copyToClipboard(CODE_SNIPPED)} />
          </Flex>
        </VerifyStep>

        <VerifyStep step={3} title={'Complete the captcha and paste the token'}>
          After the captcha, the token will appear in the console — paste it here:
        </VerifyStep>

        <Box pl={'28px'}>
          <Controller
            control={control}
            name={`hv_token`}
            rules={{required: true}}
            render={({field: {onChange, value}}) => {
              return (
                <Input
                  value={value}
                  autoComplete={'off'}
                  placeholder={'Paste token from console ...'}
                  onChange={(e) => {
                    onChange(e.target.value);
                  }}
                />
              );
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
};
